import { biLogger } from '../biLogger';
import { BiEventLogger } from '../types';
import { getRuntimeDataForBi } from '../utils';

export type KeraSessionEndBiData = Readonly<{
  keraSessionId: string;
}>;

export const logKeraVoiceAssistantSessionEnd: BiEventLogger<KeraSessionEndBiData> = async (
  state,
  { keraSessionId },
) => {
  const { sessionId } = await getRuntimeDataForBi(state);

  biLogger.keraVoiceAssistantSessionEnd({
    self_service_session_id: sessionId,
    kera_session_id: keraSessionId,
  });
};
